<template>
  <v-dialog v-model="dialog" :max-width="590">
    <v-card>
      <v-card-title primary-title>
        <div class="headline">Comandos</div>
      </v-card-title>
      <v-card-text>
        <v-alert type="warning" :value="true">{{ warningText }}</v-alert>
      </v-card-text>
      <v-card-text>
        <div v-if="loading" class="loading mt-5">
          <v-layout row justify-center>
            <v-progress-circular indeterminate :size="100" color="primary"/>
          </v-layout>
        </div>
        <div v-else class="commands">
          <v-layout row justify-center>
            <v-btn
              v-for="(command, index) in commands"
              :key="index"
              color="primary"
              :loading="sendingCommand"
              @click="sendCommand({ commandId: command.id })"
            >
              {{ command.alias }}
              <v-icon right dark>cloud_upload</v-icon>
            </v-btn>
          </v-layout>
        </div>
      </v-card-text>
      <v-card-text>
        <v-alert color="error" icon="warning" v-model="errorAlert">{{ errorAlertText }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="dialog = false">cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'commands-dialog',
  data: function () {
    return {
      dialog: false,
      loading: false,
      vehicleId: null,
      warningText: 'Algunos comandos pueden generar comportamientos inesperados en los vehículos. Apagar un vehículo mientras se desplaza a altas velocidades puede generar una pérdida del control del mismo.',
      errorAlertText: 'El dispositivo no recibió el comando, vuelve a intentarlo.'
    }
  },
  computed: {
    commands: function () {
      return this.$store.getters['CommandsDialog/commands']
    },
    commandTransferStatus: function () {
      return this.$store.state.CommandsDialog.commandTransferStatus
    },
    sendingCommand: function () {
      const processes = ['SENDING', 'PENDING']
      return processes.includes(this.commandTransferStatus)
    },
    errorAlert: function () {
      return this.commandTransferStatus === 'ERROR'
    }
  },
  methods: {
    open: async function ({ vehicleId }) {
      if (!vehicleId) throw new Error('Vehicle id is missing.')
      this.vehicleId = vehicleId
      this.dialog = true
      this.loading = true
      await this.$store.dispatch('CommandsDialog/fetchVehicle', { vehicleId })
      this.loading = false
    },
    sendCommand: async function ({ commandId }) {
      await this.$store.dispatch('CommandsDialog/connectToCommandsServer')
      this.$store.dispatch('CommandsDialog/sendCommand', {
        commandId,
        vehicleId: this.vehicleId
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CommandsDialog.vue